.container {
  width: 100%;
  max-width: 92.8rem;
  margin: 0 auto;
  padding: 1.6rem;
}

.description {
  line-height: 2.4rem;
  color: #e6edf3;
  max-width: 64rem;
  overflow-wrap: break-word;

  a {
    color: white;
    text-decoration: underline;
  }
}

.description-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  margin-top: 2rem;
}
